type MailCopy = {
    internetMessageId: string;
    aiDetails?: unknown;
};

/**
 * Copie du message ouvert qui porte l'analyse, parmi les copies du fil (envoyé à soi-même, archive,
 * corbeille). La copie du fil prime sur le mail ouvert ; sans copie analysée, une copie du message.
 */
export const findAnalyzedCopy = <T extends MailCopy>(
    openedMail: T,
    threadMails: readonly T[] = [],
): T => {
    const sameMessageCopies = threadMails.filter(
        (threadMail) =>
            threadMail.internetMessageId === openedMail.internetMessageId,
    );

    return (
        sameMessageCopies.find((threadMail) => threadMail.aiDetails) ??
        (openedMail.aiDetails ? openedMail : sameMessageCopies[0]) ??
        openedMail
    );
};
